import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Checkbox,
    Grid,
    InputAdornment,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { LOGO, ROUTES } from '../util/constants';
import { isRenault } from '../util/constants';
import { useTheme } from '@emotion/react';

import { useLocation, useNavigate } from 'react-router-dom';
import CustomLinearProgress from '../components/CustomLinearProgress';
import styled from '@emotion/styled';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { removeTimeInfo, setDealerInfo, setVale } from '../redux/form';
import { nextStep, previousStep } from '../redux/step';
import { setLoading } from '../redux/loading';
import { getTimeSlots } from '../services';
import { setTimeSlots } from '../redux/timeSlots';
import { showError } from '../redux/snackbar';
import CustomCard from '../components/CustomCard';
import NewMap from './NewMap';

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    minHeight: 'unset',
    paddingLeft: 0,
    paddingRight: 0,
    '&$expanded': {
        margin: '0px',
        marginBottom: theme.spacing(1),
        minHeight: 'unset',
    },
    content: {
        margin: '0px',
        '&$expanded': {
            margin: '0px',
            marginBottom: theme.spacing(1),
        },
    },
    expanded: {},
}));


const spacingRoot = { xs: 2, sm: 2, md: 2, lg: 3, xl: 4 }

function Form2(props) {
    const theme = useTheme()
    // Styles
    const styles = {
        formRoot: {
            width: '100%',
            height: '100%'
        },
        leftColumnRoot: {
            [theme.breakpoints.down('md')]: {
                flex: '0 0 65%',
            }
        },
        rightColumnRoot: {
            [theme.breakpoints.down('md')]: {
                flex: '1 0 0',
            },
            minHeight: '600px'
        },
        checkboxChecked: {
            color: theme.palette.success.main,
        },
        accordionRoot: {
            width: '100%',
            flex: '0 1 0',
            boxShadow: theme.shadows[0],
        },
        accordionDetails: {
            minHeight: 'unset',
            padding: 0,
        },
        accordionIconButton: {
            padding: 0,
            marginRight: 0
        },
    }

    // Props
    const { t } = useTranslation()

    const dispatch = useDispatch()
    const loading = useSelector(state => state.loading)
    const form = useSelector(state => state.form)
    const portLogin = useSelector(state => state.portLogin)
    const vehicle = useSelector(state => state.vehicle)
    const [dealer, setDealer] = useState(undefined)
    const [isListVisible, setIsListVisible] = useState(false)
    const [handleFindLocation, setHandleFindLocation] = useState(undefined);

    const [selectedDealer, setSelectedDealer] = useState(null);

    const [expanded, setExpanded] = useState(false);


    const dealers = useSelector(state => state.dealers)
    const [dealersWithDistance, setDealersWithDistance] = useState(null);

    const { search } = useLocation()
    const searchParams = new URLSearchParams(search)
    const dealerCodeParam = searchParams.get('dealerCode');
    const platformParam = searchParams.get('platform');
    const ISS_DEALER_CODES = ['98449', '06701', '16701', '34701', '35701'];
    const isIssPlatform = platformParam === 'iss';
    const issDealers = isIssPlatform ? dealers.filter(dealer => ISS_DEALER_CODES.includes(dealer.code)) : null;
    const dealerFromParam = dealers.find(dealer => dealer.code === dealerCodeParam);

    const [filterDealers, setFilterDealers] = useState(dealerFromParam ? [dealerFromParam] : (issDealers || dealers));

    const navigate = useNavigate();

    useEffect(() => {
        if (dealerCodeParam && dealers.length > 0 && dealerFromParam === undefined) {
            navigate(ROUTES.DEFAULT);
        }
    }, [dealers])


    const [filter, setFilter] = useState(dealerFromParam?.shortName || '');
    const [valeFilter, setValeFilter] = useState(form.vale);
    const [sellerFilter, setSellerFilter] = useState(false);
    const [serviceFilter, setServiceFilter] = useState(false);
    const [dakikFilter, setDakikFilter] = useState(false);
    const [mekanikFilter, setMekanikFilter] = useState(false);


    // Media query screen size
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));

    // Calculate spacing 
    const spacingForm = useMemo(() => {

        const spacings = { xs: 2, sm: 2, md: 3, lg: 3, xl: 4 }

        if (xsDown) {
            return spacings.xs
        }
        else {
            if (smDown) {
                return spacings.sm
            }
            else {
                if (mdDown) {
                    return spacings.md
                }
                else {
                    if (lgDown) {
                        return spacings.lg
                    }
                    else {
                        if (xlDown) {
                            return spacings.xl
                        }
                        else {
                            return spacings.xl
                        }
                    }
                }
            }
        }

    }, [xsDown, smDown, mdDown, lgDown, xlDown]);
    //GA DataLayer
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'formSteps',
            'pageName': isRenault ? 'Renault_Servis_Randevusu' : 'Dacia_Servis_Randevusu',
            'businessType': 'after-sales',
            'pageType': 'form',
            'formName': 'Online Servis Randevusu',
            'formType': 'service-request',
            'formCategory': 'lead-after-sales',
            'formStepName': 'step-2',
            'formStepNumber': 'step-2',
            'vehicleId': portLogin ? vehicle.id : "",
            'vehicleModel': portLogin ? vehicle.modelName : form.vehicleModel
        });
    }, [])

    // Form error states
    const [dealerError, setDealerError] = useState(false);



    // Previous step
    function handleBackButton() {
        dispatch(previousStep())
    }


    // Next step
    function handleNextStep() {

        if (loading) { return }

        // Form validation
        let error = false;
        if (!dealer) {
            error = true
            setDealerError(true)
        }

        // Don't proceed if there is an error  TODO:
        if (!error) {

            // If dealer chanced get timeslots and next step
            if (form.dealer !== dealer) {

                // Set loading
                dispatch(setLoading(true))

                getTimeSlots(dealer.id)
                    .then(timeSlots => {

                        // Deselect time info
                        dispatch(removeTimeInfo())

                        // Save time slots info
                        dispatch(setTimeSlots(timeSlots))

                        // Save dealer info to redux
                        dispatch(setDealerInfo({
                            dealer,
                        }))

                        dispatch(nextStep())
                    })
                    .catch(e => {
                        console.error(e)
                        dispatch(showError(t('UNKNOWN_ERROR')))
                    })
                    .finally(() => {
                        dispatch(setLoading(false))
                    })
            }
            // Next step
            else {
                dispatch(nextStep())
            }

        }

    }

    // On mount dealer
    useEffect(() => {
        if (dealer)
            handleNextStep()
    }, [dealer])


    function getCardActions() {
        return (
            <Grid container direction="column" spacing={1} wrap='nowrap' style={{ position: 'relative' }}>

                {/* Error Text */}
                {
                    dealerError &&
                    <Grid item xs={12}>
                        <Box w={1} alignItems='center'>
                            <Typography variant='body2' color='error'>{`${t('dealerError')}`}</Typography>
                        </Box>
                    </Grid>
                }
                <Grid item xs={12}>
                    <Box display='flex' justifyContent='space-between'>

                        <Button
                            variant="contained"
                            sx={styles.button}
                            onClick={handleBackButton}
                            style={{ width: xsDown ? '40%' : '170px', minHeight: '42px', boxShadow: 'none', marginRight: '2px' }}
                        >
                            {t('backButton')}
                        </Button>
                        <Button
                            variant="contained"
                            style={{ width: xsDown ? '40%' : '170px', minHeight: '42px', boxShadow: 'none', marginLeft: '2px' }}
                            onClick={handleNextStep}>
                            {t('nextButton')}
                        </Button>
                    </Box>

                </Grid>
            </Grid>
        );
    }

    const handleList = () => {
        setIsListVisible(!isListVisible);
        setSelectedDealer(null);
    };

    function getFilter() {
        return (
            <Grid container direction="column" wrap='nowrap' spacing={spacingForm}>

                {/* Map Filter */}
                <Grid item container xs={12} direction="row" wrap='nowrap' style={{ display: "flex", alignItems: "center" }}>
                    <TextField
                        label={t('filter')}
                        fullWidth
                        size={smDown ? 'small' : 'medium'}
                        variant='outlined'
                        disabled={dealerCodeParam}
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        InputProps={{
                            endAdornment:
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                        }}
                    />

                    <Button variant="contained" disableElevation
                        style={{ margin: xsDown ? "0px 2px 0px 5px" : "0 5px 0 10px", width: "150px", height: "50px", fontSize: xsDown ? '13px' : '0.875rem' }}
                        onClick={handleList}
                    >
                        {isListVisible ? t('mapView') : t('listView')}
                    </Button>

                    <Button disableElevation variant="contained"
                        disabled={!dealersWithDistance}
                        style={{ margin: xsDown ? "0px 2px 0px 5px" : "0 5px 0 10px", width: "180px", height: "50px", fontSize: xsDown ? '12px' : '0.875rem' }}
                        onClick={() => handleFindLocation()}
                        width="25px">
                        {t('nearby')}
                    </Button>
                </Grid>

                <Grid item xs={12}>{getAccordion()}</Grid>

            </Grid>
        )
    }

    function getListViewDealers() {
        return (
            <Grid container direction="column" nowrap="true">

                <List style={{ width: 'inherit' }}>
                    {
                        filterDealers.map((item, index) =>
                            <ListItem key={index}>
                                <ListItemAvatar>
                                    <img
                                        width={40}
                                        alt=''
                                        src={LOGO.MARKER}
                                    />
                                </ListItemAvatar>
                                <Grid item container direction="row" nowrap="true">
                                    <ListItemText
                                        primaryTypographyProps={{ style: { color: theme.palette.mode === 'dark' ? 'white' : 'black' } }}
                                        style={{ paddingRight: "80px", wordBreak: 'break-word' }}
                                        primary={item.name} secondary={item.distance ? (item.address + " - " + item.city + ` - ${Math.round(item.distance / 10) / 100} km`) : (item.address + " - " + item.city)} />
                                    <Grid item container direction="row" nowrap="true">
                                        <Grid item style={{ display: "inline-flex" }}>
                                            {
                                                item.isVale ?
                                                    <ListItemText style={{ marginRight: "5px" }} secondary={"Vale Hizmeti - "} />
                                                    : null
                                            }
                                            {
                                                item.isSale ?
                                                    <ListItemText style={{ marginRight: "5px" }} secondary={"Yetkili Satıcı - "} />
                                                    : null
                                            }
                                            {
                                                item.isService ?
                                                    <ListItemText style={{ marginRight: "5px" }} secondary={"Yetkili Servis"} />
                                                    : null
                                            }
                                        </Grid>

                                    </Grid>
                                </Grid>

                                <ListItemSecondaryAction>
                                    <Button variant="contained" color="primary" onClick={() => setDealer(item)}>
                                        {t('buttonChoose')}
                                    </Button>
                                </ListItemSecondaryAction>
                            </ListItem>
                        )
                    }
                </List>

            </Grid>
        )
    }

    function getAccordion() {

        function getCheckBox(checked, onChange, title) {
            return (
                <Grid item xs={'auto'} style={{ paddingTop: 0, paddingBottom: 0 }}>
                    <Box display='flex' alignItems='center' ml='-11px'>
                        <Checkbox
                            checked={checked}
                            onChange={onChange}
                            color='default'
                            size={smDown ? 'small' : 'medium'}
                            sx={{ '&.Mui-checked': styles.checkboxChecked }}
                        />
                        <Typography variant='body2' color='textPrimary'>{title}</Typography>
                    </Box>
                </Grid>
            )
        }

        return (
            <Accordion
                expanded={expanded}
                onChange={(event, expanded) => {
                    setExpanded(expanded)
                }}
                square
                sx={styles.accordionRoot}
            >

                {/* Summary */}
                <StyledAccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    IconButtonProps={{ sx: styles.accordionIconButton }}
                >
                    <Typography variant='body1' color='textPrimary'>{t('filterTitle')}</Typography>
                </StyledAccordionSummary>

                {/* Details */}
                <AccordionDetails sx={styles.accordionDetails}>
                    <Grid container spacing={2}>

                        {/* valeFilter */}
                        {getCheckBox(valeFilter, e => { setValeFilter(e.target.checked); dispatch(setVale({ vale: e.target.checked })); }, t('filterVale'))}

                        {/* sellerFilter */}
                        {getCheckBox(sellerFilter, e => setSellerFilter(e.target.checked), t('filterSeller'))}

                        {/* serviceFilter */}
                        {getCheckBox(serviceFilter, e => setServiceFilter(e.target.checked), t('filterService'))}

                        {/* dakikFilter 
                        {getCheckBox(dakikFilter, e => setDakikFilter(e.target.checked), t('filterDakik'))}

                         mekanikFilter
                        {getCheckBox(mekanikFilter, e => setMekanikFilter(e.target.checked), t('filterMekanik'))} */}
                    </Grid>
                </AccordionDetails>

            </Accordion>
        )
    }

    const getFilterDealers = (e) => {
        if (!dealersWithDistance) return
        setFilterDealers(
            (dealersWithDistance).filter(
                (dealer) =>
                    ((dealer.shortName
                        .toLocaleLowerCase('tr')
                        .includes(filter.toLocaleLowerCase('tr')) ||
                        dealer.city.toLocaleLowerCase('tr').includes(filter.toLocaleLowerCase('tr')) ||
                        dealer.district.toLocaleLowerCase('tr').includes(filter.toLocaleLowerCase('tr'))) && (
                            ((valeFilter && dealer.isVale) || (!valeFilter))
                            &&
                            ((sellerFilter && dealer.isSale) || (!sellerFilter))
                            &&
                            ((serviceFilter && dealer.isService) || (!serviceFilter))
                            &&
                            ((dakikFilter && dealer.isDakik) || (!dakikFilter))
                            &&
                            ((mekanikFilter && dealer.isMekanik) || (!mekanikFilter))))
                    && (dealerFromParam ? dealer.code === dealerFromParam.code : true) // If dealer code is provided, only show that dealer
                    && (isIssPlatform ? ISS_DEALER_CODES.includes(dealer.code) : true) // If platform=iss, restrict to ISS dealers
            )
        );
    };

    useEffect(() => {
        getFilterDealers()
    }, [valeFilter, sellerFilter, serviceFilter, dakikFilter, mekanikFilter, filter, dealersWithDistance]);

    const body = () => {
        return (
            <>
                {getFilter()}
                {isListVisible ?
                    getListViewDealers()
                    :
                    <NewMap
                        setDealer={setDealer}
                        setIsListVisible={setIsListVisible}
                        filterDealers={filterDealers}
                        setFilterDealers={setFilterDealers}
                        dealersWithDistance={dealersWithDistance}
                        setDealersWithDistance={setDealersWithDistance}
                        selectedDealer={selectedDealer}
                        setSelectedDealer={setSelectedDealer}
                        handleFindLocation={handleFindLocation}
                        setHandleFindLocation={setHandleFindLocation}
                    />
                }

            </>
        );
    }

    return (
        <>
            {/* Form */}
            <Grid container item xs={12} md={6} sx={styles.rightColumnRoot}>
                <Box width={1} height={1} position='relative'>
                    {/* Loading */}
                    {/* TODO: decide whether to render or not during loading */}
                    <CustomLinearProgress loading={loading} />
                    <CustomCard
                        padding={spacingRoot}
                        content={body()}
                        overFlow={!isListVisible}
                        action={getCardActions()} />
                </Box>
            </Grid>
        </>
    )
}

// Connect redux and translation
export default Form2